import {VatRate} from "../../libs/enum/vat-rate.enum";
import {isTrue, notDefined} from "../../libs/utils/epic.utils";
import {ItemUnit} from "../../libs/enum/item-unit.enum";

export class ArticleDto {

  public id!: string;
  public number!: string;
  public name!: string;
  public unit!: ItemUnit;
  public vatRate!: VatRate;
  public ean: string | undefined;
  public sellingPriceNet!: number;
  public sellingPriceGross!: number;
  public purchasingPriceNet: number | undefined;
  public purchasingPriceGross: number | undefined;
  public currencyCode!: string;
  public oldPart!: boolean;
  public dangerousGoods!: boolean;
  public sparePart!: boolean;
  public discountable!: boolean;
  public readonly updatable!: boolean;
  public readonly editable!: boolean;
  public externalId: string | undefined;
  public externalNumber: string | undefined;
  public catalogId: string | undefined;
  public goodsGroupId: string | undefined;
  public notes: string | undefined;
  public manufacturer: string | undefined;
  public originCountryCode: string | undefined;

  constructor(init?: Partial<ArticleDto> | undefined) {
    Object.assign(this, init);
    // Default value for a new article
    if (notDefined(this.discountable)) {
      this.discountable = true;
    }
  }

  public isEditable(): boolean {
    return isTrue(this.editable);
  }

  public articleClone(): ArticleDto {
    const article = new ArticleDto(this);
    article.id = "";
    article.number = "";
    return article;
  }
}
